<template>
  <div class="relative" v-if="banners.length">
    <div class="block-sliders-navigation" v-if="banners.length > 1">
      <div class="sliders-navigation">
        <div class="button-sliders">
          <button class="brdr-none bg-cl-transparent " @click="showPrevious">
            <span class="material-icons">west</span>
          </button>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="button-sliders">
          <button class="brdr-none bg-cl-transparent " @click="showNext">
            <span class="material-icons">east</span>
          </button>
        </div>
      </div>
    </div>

    <swiper class="swiper relative" :options="banners.length > 1 ? swiperOption : swiperOptionOneBanner" ref="shopPromo">
      <swiper-slide v-for="(banner, index) in banners" :key="banner.id" class="slider-block-slide">
        <a :href="banner.link ? banner.link : ''">
          <div class="promo-item relative">
            <img
              :src="index === 0 ? bannerPath(banner.image) : ''"
              :data-src="index !== 0 ? bannerPath(banner.image) : ''"
              class="swiper-lazy"
              :alt="'promo-banner'"
              :height="imageHeight"
              :width="imageWidth"
              loading="eager"
              fetchpriority="high"
            >
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {s3Path} from "@vue-storefront/core/helpers";
import config from "config";

export default {
  computed: {
    ...mapGetters({
      currentPartnerCode: 'partners/getCurrentPartnerCode',
      currentPartner: 'partners/getCurrentPartner'
    }),
    banners () {
      return this.currentPartner.promotions
    },
    imageHeight () {
      return config.images.partner_shop_banner.height
    },
    imageWidth () {
      return config.images.partner_shop_banner.width
    }
  },
  data () {
    return {
      arrayImages: [
        '../../../../../assets/shop/banners/bri.jpeg',
        '../../../../../assets/shop/banners/cheese.jpeg',
        '../../../../../assets/shop/banners/feta.jpeg',
        '../../../../../assets/shop/banners/parmesan.jpeg',
        '../../../../../assets/shop/banners/rum.jpeg',
        '../../../../../assets/shop/banners/novus-banner-buy-online.jpg',
        '../../../../../assets/shop/banners/novus-banner-choose-time.jpg'
      ],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        observer: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
          delay: 3000
        },
        loop: true,
        lazy: {
          threshold: 50,
          sequential: false,
          observer: true,
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: false
        },
        preloadImages: false,
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      swiperOptionOneBanner: {
        slidesPerView: 1,
        spaceBetween: 30,
        observer: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  beforeDestroy () {
    const swiper = this.$refs.shopPromo && this.$refs.shopPromo.$swiper
    if (swiper && swiper.initialized) {
      swiper.destroy(true, true)
    }
  },
  methods: {
    bannerPath (path) {
      return s3Path(path, config.images.partner_shop_banner.width, config.images.partner_shop_banner.height)
    },
    showPrevious () {
      this.$refs.shopPromo.$swiper.slidePrev()
    },
    showNext () {
      this.$refs.shopPromo.$swiper.slideNext()
    }
  }
}
</script>

<style lang="scss" scoped>
.block-sliders-navigation {
  z-index: 3;
  position: absolute;
  top: auto;
  bottom: 10px;
  right: 10px;
  .sliders-navigation {
    display: flex;
    background: #fff;
    padding: 10px 20px;
    border-radius: 25px;
    opacity: 0.8;
    @media (max-width: 768px) {
      padding: 0;
      background: none;
    }
    .button-sliders {
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    right: 0;
    bottom: -20px;
    width: 100%;
  }
}
.swiper-pagination {
  position: static;
  place-self: center;
  margin-bottom: 3px;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0;
  }
}
</style>
<style lang="scss">
.default-layout {
  .promo-item {
    display: flex;

    overflow: hidden;
    border-radius: 45px;
    height: 350px;

    @media only screen and (max-width: 1199px) {
      height: 280px;
    }

    @media only screen and (max-width: 991px) {
      height: 220px;
    }

    @media only screen and (max-width: 768px) {
      height: 160px;
      border-radius: 15px;
    }

    @media only screen and (max-width: 576px) {
      height: 145px;
    }

    @media only screen and (max-width: 425px) {
      height: 120px;
      border-radius: 10px;
    }

    & img {
      width: 100%;
      height: 100%;
      object-position: center;

      @media only screen and (min-width: 576px) {
        object-fit: cover;
      }
    }
  }
}

.shop-layout {
  .promo-item {
    display: flex;

    overflow: hidden;
    border-radius: 45px;
    height: 260px;

    @media only screen and (max-width: 1199px) {
      height: 200px;
      border-radius: 24px;
    }

    @media only screen and (max-width: 991px) {
      height: 220px;
    }

    @media only screen and (max-width: 768px) {
      height: 160px;
      border-radius: 15px;
    }

    @media only screen and (max-width: 576px) {
      height: 145px;
    }

    @media only screen and (max-width: 425px) {
      height: 120px;
      border-radius: 10px;
    }

    & img {
      width: 100%;
      height: 100%;
      object-position: center;

      @media only screen and (min-width: 576px) {
        object-fit: cover;
      }
    }
  }
}

.block-sliders-navigation .swiper-pagination-bullet {
  margin: 0 2px;
}
</style>
